var params = location.hash.replace('#', '').split('&');
var shapeValues = false;
params.forEach(function(param) {
    var param_val = param.split('=');
    var key = param_val[0];
    var values_str = param_val[1];
    if (key === 'shape') {
        shapeValues = values_str.split(',');
    }
});

var exclude_vvs1 = !!shapeValues;

var colorList = ["D", "E", "F", "G", "H", "I", "J"];
var clarityList = ["SI2", "SI1", "VS2", "VS1", "VVS2", "IF", "FL"];
if (!exclude_vvs1) {
    //clarityList.push('VVS1');
}
var cutList = ['VG', 'EX', 'ID'];
var cutListObject = {
    'ID': 'Ideal',
    'EX': 'Excellent',
    'VG': 'Very Good'
};

 // sort shapes
var shapeList = ['round', 'oval'];

const BASE_URL = '////luxurydiamondsapp.org';

console.log(shapeValues, BASE_URL);

var page = 1;
var loading = false;
var hasMore = true;

var productQuery = {
    'filter' : {
        'vendor' : [
            'Skylab',
            'EcoLight'
        ],
    },
    'limit' : 20,
    'page' : page,
    //'exclude_vvs1': exclude_vvs1
};

if (shapeValues) {
    productQuery.filter.shape = shapeValues;
}
